import Thumbnail from "../assets/images/sendsms-thumbnail.png";
import SendSmsDemo from "../assets/video/SendSmsVideo.mp4";
import { urlParams } from "./../constants/AppConstants";

function getAllUrlParams() {
  var allUrlParams = new URLSearchParams(window.location.search);
  var resourceObj = {};
  for (var key of allUrlParams.keys()) {
    resourceObj[key] = allUrlParams.get(key);
  }
  var resourceStr = JSON.stringify(resourceObj);
  return encodeURIComponent(resourceStr);
}
export let Salesforce = {
  service: "Salesforce",
  isOmniLicense: true,
  productId: "102",
  isInboxEnabled: true,
  isWorkflowTableFormat: true,
  primaryPhoneApiName: "phone",
  secondaryPhoneApiName: "mobile",
  isWorkflowtext: "Webhook",
  workFlowIconInTemplates: false,
  api: "api/v2/",
  addUserButton: false,
  redirectPath: "/persons/list",
  associatedLookup: false,
  landingPagePathname: "/salesforce/landing",
  SMS_GALLERY: [
    {
      videoUrl: "https://www.youtube.com/embed/Wda4VwYptQY",
    },
    {
      videoUrl: "https://www.youtube.com/embed/LuegcRXHeNM",
    },
    {
      videoUrl: "https://www.youtube.com/embed/dq8a6bipY2s",
    },
  ],
  VOICE_GALLERY: [
    {
      videoUrl: "https://www.youtube.com/embed/tbvIB0WfFVQ",
    },
    {
      videoUrl: "https://www.youtube.com/embed/s_actXvJJHY",
    },
  ],
  WHATSAPP_GALLERY: [
    {
      headline: "Boost Sales with Direct WhatsApp Messaging in Pipedrive",
      sourceUrl: "https://www.youtube.com/embed/aB6BTkcRBaM?si=7evfv3ukmLAh9Tul",
      steps: ["Send WhatsApp messages to Pipedrive prospects", `Track all conversation history within Pipedrive`],
    },
    {
      headline: `Automate SMS/WhatsApp message for Appointment Scheduling in Pipedrive`,
      sourceUrl: "https://www.youtube.com/embed/ojia6Q7VXYM?si=72NEoKwJYlOw8ais",
      steps: ["Create a Webhook URL", `Set up automation in Pipedrive`],
    },
    {
      headline: `Automate SMS/WhatsApp message When Deal Stages Change in Pipedrive`,
      sourceUrl: "https://www.youtube.com/embed/QMEwqIIxyI8?si=xYp5UV_UlaQL6ZZb",
      steps: ["Send templated messages for each deal stage", `Boost conversions with timely engagement`],
    },
  ],
  automationPageHelpVideo: [
    {
      headline: "Automate SMS / WhatsApp messages for Deal Stage Changes",
      sourceUrl: "https://www.youtube.com/embed/XFV0FuCd8rw",
      steps: ["Send automatic messages to clients when deals progress in Pipedrive"],
    },
    {
      headline: "Automate SMS / WhatsApp messages  for Pipedrive Activities",
      sourceUrl: "https://www.youtube.com/embed/HAu_dA1DLnE",
      steps: ["Setup automation whenever an activity is newly created in Pipedrive"],
    },
    {
      headline: "Automate SMS / WhatsApp messages for Appointment Scheduling",
      sourceUrl: "https://www.youtube.com/embed/5IqYa64KrnQ",
      steps: ["Manage your appointments with automated messages for scheduling, rescheduling, and cancellations."],
    },
    {
      headline: "Configuring Messaging Automation",
      sourceUrl: "https://www.youtube.com/embed/XFV0FuCd8rw",
      steps: ["Learn how to set up automatic SMS/WhatsApp notification in 2 simple steps"],
    },
    {
      headline: "Automate SMS / WhatsApp messages in Pipedrive.",
      sourceUrl: "https://www.youtube.com/embed/XFV0FuCd8rw",
      steps: [`Learn to automate in Pipedrive for your business needs.`],
    },
  ],
  sendSmsVideoComponent: <video width={"100%"} height={"100%"} className="mt-2" poster={Thumbnail} src={SendSmsDemo} controls />,
  sideBarExtend: {
    landingPagePathname: "/salesforce/landing",
    serviceSideBar: true,
    inboxSidebar: true,
    conversationSidebar: false,
    sendSmsSidebar: false,
    sendBulkSmsSidebar: false,
    campaignSidebar: true,
    pagesSidebar: false,
    campaignOverviewSidebar: true,
    usersSideBar: true,
    hideSMSTabsInSideBar: false,
    settingSideBar: true,
    hideVoiceSideBar: true,
  },
  planDetails: {
    topPlan: "Gold",
    topPlanKey: "PD_GOLD",
    topPlanId: "Gold-USD-Monthly",
    totalUsers: 3,
  },
  pricingLink: function (appProperties) {
    return new Promise((resolve, reject) => {
      const { hash, osyncId, domain } = appProperties;
      var leftServiceId = urlParams.get("leftServiceId");
      var leftServiceName = urlParams.get("service");
      var allUrlParams = getAllUrlParams();
      var redirectSendSMSFromModule = domain + "/persons/list";
      var hrefUrl = `/pricing?productId=102&groupName=OMNI_CHANNEL&domain=${domain}&hash=${hash}&leftServiceId=${leftServiceId}&osyncId=${osyncId}&service=${leftServiceName}&urlParams=${allUrlParams}&serviceOrigin=${redirectSendSMSFromModule}`;
      resolve(hrefUrl);
    });
  },
  getWebhookContent: function (fetchData, fetchWebhookNotifications, appProperties) {
    return new Promise((resolve, reject) => {
      let integId = appProperties?.randomIntegId;
      fetchData("omessage/" + integId + "/webhookNotifications", "GET", null, appProperties).then((response) => {
        let webhookNotification = JSON.parse(response);
        resolve(webhookNotification);
      });
    });
  },
  getUserData: function () {
    var companyId = urlParams.get("companyId");
    var emailId = urlParams.get("email");
    var userId = urlParams.get("userId");
    var domain = urlParams.get("domain");
    var companyOrgId = companyId;
    return new Promise((resolve, reject) => {
      var userData = {
        companyId: companyId,
        userId: userId,
        companyOrgId: companyOrgId,
        domain: domain,
        emailId: emailId,
      };
      resolve(userData);
    });
  },
  getAssociatedObjectId: function (thisObj) {
    return new Promise((resolve, reject) => {
      resolve(urlParams.get("selectedIds"));
    });
  },
  getAssociatedObjectType: function (thisObj) {
    return new Promise((resolve, reject) => {
      resolve(urlParams.get("resource"));
    });
  },
  getAssociatedObjectTypeInPlural: function (thisObj) {
    return new Promise((resolve, reject) => {
      resolve(urlParams.get("resource") + "s");
    });
  },

  fetchContact: function (fetchData) {
    return new Promise((resolve, reject) => {
      let phoneNumber = urlParams.get("phone")?.trim();
      resolve(phoneNumber);
    });
  },
  getSubscriptionId: function (fetchSubscriptionData, appProperties) {
    return new Promise((resolve, reject) => {
      fetchSubscriptionData(appProperties).then((response) => {
        resolve(response);
      });
    });
  },
  getUrlParamsForRedirection: function (isNewWindow, appProperties) {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    urlParams.delete("source");
    return new Promise((resolve, reject) => {
      var redirectUrl = `leftServiceId=${appProperties.leftServiceId}&service=salesforce&userId=${appProperties.userId}&companyId=${appProperties.companyId}`;
      if (token) {
        redirectUrl += `&token=${token}`;
      }
      resolve(redirectUrl);
    });
  },
  fetchContactsCount: function (fetchFilterInfoByFilterId, appProperties, integId, module) {
    return new Promise((resolve, reject) => {
      var selectedIds = urlParams.get("selectedIds");
      var excludedIds = urlParams.get("excludedIds");
      this.getFilterObjectForShrinkView().then((filterObject) => {
        let filterId = filterObject?.filterId;
        let filterType = filterObject?.filterType;
        let filter = filterObject?.filter;

        if (!filterId && (selectedIds || excludedIds)) {
          filterId = "-1";
        }

        if (filterId) {
          fetchFilterInfoByFilterId(
            appProperties,
            integId,
            module,
            filterId,
            selectedIds,
            excludedIds,
            appProperties?.leftServiceId,
            filterType,
            filter
          ).then(function (response) {
            if (response?.count) {
              resolve(response?.count);
            }
          });
        }
      });
      // }
    });
  },

  getFilterObjectForShrinkView: function () {
    return new Promise((resolve, reject) => {
      var filterId = "";
      var filterType = 0;
      let filterFromParams = urlParams.get("filter");
      try {
        const filterJson = JSON.parse(filterFromParams);
        if (filterJson) {
          var filterObjectKey = Object.keys(this.filterTypeMap).find((filterTypeObjectKey) => filterJson[filterTypeObjectKey]);
          if (filterObjectKey !== "everyone") {
            filterType = this.filterTypeMap[filterObjectKey];
            filterId = filterJson[filterObjectKey];
          } else {
            filterId = "-1";
          }
        }
      } catch (error) {}
      resolve({
        filterId: filterId,
        filterType: filterType,
        filter: filterFromParams,
      });
    });
  },
  getSettingPreference: function () {
    return new Promise((resolve, reject) => {
      const controllerSpecificSettings = ["createNewLeadOnInboundSMS"];

      resolve({
        settingsToInclude: controllerSpecificSettings,
      });
    });
  },
  getApplicationToken: function () {
    var token = urlParams.get("token");
    return new Promise((resolve, reject) => {
      resolve(token);
    });
  },
};
